import { useEffect } from "react";

import { useAutoscroll } from "../../../utils";

interface UseMessageAutoscrollProps {
    scrollRef?: React.RefObject<HTMLDivElement | null>;
    shouldShowExpanded: boolean;
    isOverflowing: boolean;
    isLastBotMessage: boolean;
    isUnread?: boolean;
}

export function useMessageAutoscroll({
    scrollRef,
    shouldShowExpanded,
    isOverflowing,
    isLastBotMessage,
    isUnread,
}: UseMessageAutoscrollProps): void {
    const { start: startAutoscroll } = useAutoscroll(scrollRef);

    /* Only autoscroll when expanding a message and NOT if a proactive
       message comes in while the expert is scrolled up in the timeline */
    useEffect(() => {
        if (shouldShowExpanded && isOverflowing && isLastBotMessage && !isUnread) {
            startAutoscroll();
        }
    }, [shouldShowExpanded, isOverflowing, isLastBotMessage, isUnread, startAutoscroll]);
}
